import { AppDiscountHistoryFilter } from '@/dto/requestDto';
import http from '@/httpCommon/axiosClient';

class AppDiscountHistoryService {
    getAll = async (params: AppDiscountHistoryFilter) => {
        const res = await http.get('/app-discount-history', { params });
        return res?.data;
    };

    getAllByCouponType = async (params: AppDiscountHistoryFilter) => {
        const res = await http.get('/app-discount-history/coupon', { params });
        return res?.data;
    };

    getById = async (id: string) => {
        const res = await http.get(`/app-discount-history/${id}`);
        return res?.data;
    };
}

export default new AppDiscountHistoryService();